import React from 'react';
import OptimizedImage from '../player/OptimizedImage';
import styles from './ManagerArticles.module.css';

const ManagerArticles = ({ articles }) => {
    if (!articles || articles.length === 0) return null;

    return (
        <section className={styles.articlesSectionContainer}>
            <h2 className={styles.sectionHeading}>Articles</h2>
            <div className={styles.articlesGrid}>
                {articles.map((article) => {
                    const { title = '', headline = '', date = '', category = '', image = '', thumbnail = '', id = '', url = '' } = article;
                    const displayTitle = title || headline;
                    const displayImg = image || thumbnail;

                    return (
                        <a
                            key={id}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.articleCard}
                            style={{ textDecoration: 'none' }}
                        >
                            <OptimizedImage
                                src={displayImg}
                                alt={displayTitle}
                                width={400}
                                height={250}
                                unoptimized
                                className={styles.articleImage}
                            />
                            <div className={styles.articleContent}>
                                <div className={styles.articleInnerText}>
                                    <span className={styles.articleCategory}>{category}</span>
                                    <h3 className={styles.articleTitle}>{displayTitle}</h3>
                                </div>
                                <span className={styles.articleDate}>{date}</span>
                            </div>
                        </a>
                    );
                })}
            </div>
        </section>
    );
};

export default ManagerArticles;
